export const CHAVE_USUARIO = '__USUARIO_LOGIN__';
export const CHVAE_TOKEN = '__TOKEN__';
export const CACHE_EMPRESA = '__CACHE_EMPRESA__';
export const FOTO_PERFIL_PADRAO = '/perfilsemfoto.png';
export const URL_AUTH_SERVICE = 'auth.ikponto.com.br';
export const URL_SC_SERVICE = 'wss://'+URL_AUTH_SERVICE+':22620/controle/sessao/usuarios';

export const localeCalendarBR = {
    firstDayOfWeek: 1,
    dayNames: [ "Domingo","Segunda","Terça","Quarta","Quinta","Sexta","Sábado" ],
    dayNamesShort: [ "Dom","Seg","Ter","Qua","Qui","Sex","Sáb" ],
    dayNamesMin: [ "Dom","Seg","Ter","Qua","Qui","Sex","Sáb" ],
    monthNames: [ "Janeiro","Fevereiro","Março","Abril","Maio","Junho","Julho","Agosto","Setembro","Outubro","Novembro","Dezembro" ],
    monthNamesShort: [ "Jan","Fev","Mar","Abr","Mai","Jun","Jul","Ago","Set","Out","Nov","Dez" ],
    today: 'Hoje',
    clear: 'Limpar',
    weekHeader: 'Sm'
}

export const acoesSolicitacoesPendentes = [{ nome:'Aprovar', id: 'Aprovado' }, { nome:'Não Aprovar', id: 'Não Aprovado' }];

export const minTrabPortarias = [{nome: '1510', valor: '1510'}, {nome: '671', valor: '671'}];

export function exibirMensagem(vue, dataResp) {   
    if(dataResp && dataResp.response && dataResp.response.data) {        
        if(dataResp.response.status == 400 || dataResp.response.status == 401) {
            vue.$toast.add({severity:'warn', summary: 'Mensagem', detail: dataResp.response.data.mensagem, life: 10000});
        } else {
            vue.$toast.add({severity:'error', summary: 'Erro', detail: 'Oops! Algo deu errado!', life: 10000});
        }
    } else if(dataResp.status && dataResp.status == 200)  {
        vue.$toast.add({severity:'success', summary: 'OK', detail: dataResp.data.mensagem, life: 10000});
    } else {
        vue.$toast.add({severity:'error', summary: 'Erro', detail: 'Oops! Algo deu errado!', life: 10000});
    }
}

export function exibirMensagemSis(vue, mensagem, erro) {   
    if(!erro) {        
        vue.$toast.add({severity:'success', summary: 'OK', detail: mensagem, life: 10000});
    } else {
        vue.$toast.add({severity:'warn', summary: 'Mensagem', detail: mensagem, life: 10000});
    }
}

export function clonar(objeto) {
    let novo = null;      
    if (objeto instanceof Array) {
        novo = [];
        for (var i = 0, len = objeto.length; i < len; i++) {
            novo[i] = clonar(objeto[i]);
        }
        return novo;
    }      
    if (objeto instanceof Object) {
        novo = {};
        for (var attr in objeto) {
            if(objeto[attr] instanceof Object || objeto[attr] instanceof Array) {
                novo[attr] = clonar(objeto[attr])
            } else {
                novo[attr] = objeto[attr];
            }
        }
        return novo;
    }
  }

  export function formatarEtradaFloat(event) {
    if(event.keyCode != 8) {//backspace
        let valor = event.target.value.replace(/\D/g,"");
        let novo = '';
        for(let i = 0; i < valor.length; i++) {
            novo += valor.charAt(i);
            if(i == 1) {
                novo += '.'
            }
        }
        event.target.value = novo;
    }   
  }

  export function formatarEtradaHora(event) {
    let valor = event.key;   
    if(!isNaN(valor)) {
        let input = event.target.value.replace(/\D/g,"");           
        if(input.length == 1 && Number(valor) > 2) {
            event.target.value = '0'+valor+':';
        } else if(input.length == 3 && Number(valor) > 5) {
            event.target.value = input.substring(0,2)+':0'+valor;
        } else if(input.length == 2 && Number(input) > 23) {
            event.target.value = 23+':';
        } else if(input.length == 2) {
            event.target.value = input+':';
        } else if(input.length == 3) {
            event.target.value = input.substring(0,2)+':'+valor;
        }
    } else {                  
        event.target.value = event.target.value.replace(valor,'');        
    }
}

export function abrirArquivoComDefault(url) {
    // GAMBIARRA SERVIDOR DE TESTES
    if(url.includes('http://192.168.0.151:4566')) {
        url = url.replace('http://192.168.0.151:4566', 'https://200.142.122.254:8061')
    }
    window.open(url, '_blank');
}

export function preViewUrlArquivo(url) {   
    // GAMBIARRA SERVIDOR DE TESTES
    if(url.includes('http://192.168.0.151:4566')) {
        url = url.replace('http://192.168.0.151:4566', 'https://200.142.122.254:8061')
    }
	let top = (document.documentElement.clientHeight - 600) / 2;
	let left = (document.documentElement.clientWidth - 900) / 2;        
	window.open(url, 'Relatório', "width=900, height=600, top="+top+", left="+left+", scrollbars=no");
}

export function preViewArquivo(data) {   
	let top = (document.documentElement.clientHeight - 600) / 2;
	let left = (document.documentElement.clientWidth - 900) / 2;
    let file = new Blob([data], {type: 'application/pdf'});  
	window.open(URL.createObjectURL(file), 'Relatório', "width=900, height=600, top="+top+", left="+left+", scrollbars=no");
}

export function download(data, nomeArquivo) {
    let blob = new Blob([data]);
    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(blob, nomeArquivo);
    } else {
        var aLink = document.createElement('a');
        document.body.appendChild(aLink);
        var url = window.URL.createObjectURL(blob);
        aLink.setAttribute('id', Date.now());
        aLink.setAttribute('href', url);
        aLink.setAttribute("download", nomeArquivo);
        aLink.click();
        setTimeout(function() { 
            window.URL.revokeObjectURL(url);
            aLink.remove();
        }, 200);        
    }
}

export default { CHAVE_USUARIO, CHVAE_TOKEN, CACHE_EMPRESA };